import { memo, useMemo } from 'react';

import { useTranslation } from '@mint-lib/i18n';
import { usePlatforms } from '@mint-lib/routing-context';
import { SlotPortal } from '@mint-lib/slots';

import IntegrationsList from '../../components/_molecules/IntegrationsList/index.jsx';
import Filters from '../../components/features/Filters/index.js';
import { Platform } from '../../types/common.js';
import { transformPlatformsResponse } from '../../utils/platforms.js';

const Integrations = () => {
  const { t } = useTranslation('@myn/integrations_v2');

  const { platforms } = usePlatforms({
    excludeDeleted: true,
  });

  const allPlatforms = useMemo(() => {
    return (platforms ?? []).map(transformPlatformsResponse);
  }, [platforms]) as Platform[];

  return (
    <div className="flex h-[calc(100vh-96px)] flex-row items-start justify-start overflow-hidden p-0">
      <SlotPortal name="topBarTitle">{t('Integrations')}</SlotPortal>
      <Filters />
      <IntegrationsList allIntegrations={allPlatforms || []} />
    </div>
  );
};

export default memo(Integrations);
